export default __webpack_public_path__ + "static/media/img_post6_1.1679038a.png";